var map = {
	"./103_doc_back.svg": "9ad5",
	"./103_doc_front.svg": "e45a",
	"./104_doc_back.svg": "aea3",
	"./104_doc_front.svg": "c97d",
	"./ekyc_doc_poa.svg": "e457",
	"./ekyc_doc_poa_2.svg": "5bd9",
	"./ekyc_doc_selfie.svg": "2e0c",
	"./ekyc_frame.svg": "6162",
	"./ekyc_frame_poa_1.svg": "2541",
	"./ekyc_frame_poa_2.svg": "49a1",
	"./ekyc_frame_square.svg": "224c",
	"./ic_doc_upload.svg": "767c",
	"./ic_flash.svg": "2c9a",
	"./ic_green_checkmark.svg": "6492",
	"./ic_red_wrong.svg": "82be",
	"./ic_upload_poa.svg": "fb60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0dc3";